import { useLocation, Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useEffect } from "react";
import api from "../api";

export const useMaintenanceRedirect = () => {
  const location = useLocation();
  const token = JSON.parse(localStorage.getItem("token"))?.token;

  let maintenanceRoutes = [];
  try {
    maintenanceRoutes = JSON.parse(Cookies.get("maintenance_routes") || "[]");
  } catch (err) {
    console.error("Invalid maintenance_routes cookie", err);
  }

  const matchedRoute = Array.isArray(maintenanceRoutes)
    ? maintenanceRoutes.find((pattern) => {
        const regex = new RegExp("^" + pattern.replace(/:[^/]+/g, "[^/]+") + "$");
        return regex.test(location.pathname);
      })
    : null;

  useEffect(() => {
    if (matchedRoute) {
      api.post(
        `/v1/actions/insert-maintenance-log`,
        {
          route_name: matchedRoute,
          origin: "frontend",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      ).catch((err) => {
        console.error("Failed to log maintenance hit", err);
      });
    }
  }, [matchedRoute, token]);

  return matchedRoute ? <Navigate to="/maintenance" replace /> : null;
};